// import React from "react";
// import { Redirect, Route } from "react-router-dom";

// function ProtectedRoute({ component: Component, ...restOfProps }) {
//   const isAuthenticated = localStorage.getItem("isAuthenticated");
//   // const isAuthenticated = false;
//   // console.log("this", isAuthenticated);

//   return (
//     <Route
//       {...restOfProps}
//       render={(props) =>
//         isAuthenticated ? <Component {...props} /> : <Redirect to="/signin" />
//       }
//     />
//   );
// }

// export default ProtectedRoute;


import React from "react";
import { Redirect, Route } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function ProtectedRoute({ component: Component, ...restOfProps }) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.auth?.token;

  let isTokenValid = false;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000); // in seconds

      if (decoded.exp && decoded.exp > currentTime) {
        isTokenValid = true;

        // Optional: log or check role
        const role = decoded.userRole || decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        console.log("Logged in as:", role);
      }
      else {
        // Token expired
        console.warn("Token expired. Clearing localStorage.");
        localStorage.clear();
      }
    } catch (e) {
      console.error("Invalid token:", e);
      localStorage.removeItem("ManegerId");
      localStorage.removeItem("URole");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("state");
    }
  }

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isTokenValid ? <Component {...props} /> : <Redirect to="/signin" />
      }
    />
  );
}

export default ProtectedRoute;